import axios from "axios";
import authHeader from './auth.header'
import Swal from "sweetalert2";

const API_REQUEST_URL = "https://core-visitantes.aceitesa.com/";

const createRequest = ({...formData}) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = axios.post(`${API_REQUEST_URL}request/v2/create-request`,
    {...formData},config )
    Swal.fire({
      icon: "success",
      title: "Solicitud creada",
      text: `La solicitud ha sido creada con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    })
    return response.data
  }catch(error){
    if(error.response.status === 500){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Tuvimos un error al procesar tu solicitud. Intenta nuevamente`,
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
      });
    }else{
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response.data.message}`,
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
      });
    }
    return error
  }
}

export const getRequest = async (PageSize, PageNumber, filterValue=null, initialFilterDate=null, finalFilterDate=null) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  } 
  try {
  let action =  `${API_REQUEST_URL}request/v1/get-requests?PageSize=${PageSize}&PageNumber=${PageNumber}`;
  if(filterValue!=null)
  {
    action  +=`&status=${filterValue}`
  }
  if(initialFilterDate != null)
  {
    action +=`&initialddate=${initialFilterDate}`
  }

  if(initialFilterDate != null)
  {
    action +=`&finaldate=${finalFilterDate}`
  }
    const response = await axios.get(
     action,
      config
    );
    return response
  } catch (error) {
    return error
  }
}

export const getRiskEntities = async () => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  const response = await axios.get(`${API_REQUEST_URL}parameters/get-risk-entities`,
  config)
  return response.data
}

export const getCompany = async () => {
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  const response = await axios.get(`${API_REQUEST_URL}parameters/get-companies`,
  config)
  return response.data
}

export const getStaffByRequestId = async (requestId) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  const response = await axios.get(`${API_REQUEST_URL}request/v1/get-staff-by-requestId?requestId=${requestId}`, config)
  return response.data
}

export const getVehicleByRequestId = async (requestId) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  const response = await axios.get(`${API_REQUEST_URL}request/v1/get-vehicle-by-requestId?requestId=${requestId}`, config)
  return response.data
}

export const updateStatus = async (id, coments) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.put(
      `${API_REQUEST_URL}request/v1/update-status`,
      { 
        requestId: id,
        requestDescription: coments
      },
      config
    );
    Swal.fire({
      icon: "success",
      title: "Solicitud aprobada",
      text: `La solicitud ha sido aprobada con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    })
    window.location.reload()
    return response.data
  }catch(error){
    if(error.response.status === 500){
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `Tuvimos un error al procesar tu solicitud. Intenta nuevamente`,
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
      });
    }else{
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: `${error.response.data.message}`,
        confirmButtonText: "Ok",
        confirmButtonColor: "#3085d6",
      });
    }
    return error
  }
}

export const rejectRequest = async (id, coments) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.put(
      `${API_REQUEST_URL}request/v1/rejected-request`,
      { 
        requestId: id,
        requestDescription: coments
      },
      config
    );
    Swal.fire({
      icon: "success",
      title: "Solicitud rechazada",
      text: `La solicitud ha sido rechazada con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    window.location.reload()
    return response.data
  }catch(error){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${error.response.data.message}`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return error
  }
}

export const getStaffByUser = async () => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  const response = await axios.get(`${API_REQUEST_URL}request/v1/get-staff`, config)
  return response.data
}

export const getVehicleByUser = async () => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  const response = await axios.get(`${API_REQUEST_URL}request/v1/get-vehicles`, config)
  return response.data
}
//Staffs 

export const createNewStaff =  ({...data}) => {
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  try {
    const response = axios.post(
      `${API_REQUEST_URL}parameters/create-staff`,
      { ...data },
      config
    );
    return response.data;
  } catch (error) {
    return error;
  }
};

export const editStaff = async (StaffId, {...data}) =>{
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  try {
    const response = await axios.put(
      `${API_REQUEST_URL}parameters/update-staff?StaffId=${StaffId}`,
      {...data},
      config
    );
    Swal.fire({
      icon: "success",
      title: "Personal editado",
      text: `El personal ha sido editado con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return response.data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `El Personal no pudo ser editado`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return error;
  }
}

export const deleteStaff = async (StaffId) => {
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  try {
    const response = await axios.delete(
      `${API_REQUEST_URL}parameters/delete-staff?StaffId=${StaffId}`,
      config
    );
    Swal.fire({
      icon: "success",
      title: "Personal eliminado",
      text: `El personal ha sido eliminado con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    })
    document.location.reload()
    return response.data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `Tuvimos un error al procesar la solicitud`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    })
    return error;
  }
};

export const getStaff = async (userId) => {
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  const response = await axios.get(`${API_REQUEST_URL}parameters/get-staff?userId=${userId}`, config);
  return response.data;
}

//Vehicles

export const createNewVehicle = async ({...data}) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.post(
      `${API_REQUEST_URL}parameters/create-vehicle`, {...data},
      config
    );
    return response.data
  }catch(error){
    return error;
  }
}

export const editVehicle = async (VehicleId, {...data}) => {
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  try {
    const response = await axios.put(
      `${API_REQUEST_URL}parameters/update-vehicle?VehicleId=${VehicleId}`,
      {...data},
      config
    );
    Swal.fire({
      icon: "success",
      title: "Vehiculo editado",
      text: `El vehiculo ha sido editado con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return response.data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `El Vehiculo no pudo ser editado`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return error;
  }
};

export const deleteVehicle = async (vehicleId) => {
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  try {
    const response = await axios.delete(
      `${API_REQUEST_URL}parameters/delete-vehicle?VehicleId=${vehicleId}`,
      config
    );
    Swal.fire({
      icon: "success",
      title: "Vehiculo eliminado",
      text: `El vehiculo ha sido eliminado con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    })
    document.location.reload()
    return response.data;
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `Tuvimos un error al procesar la solicitud`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    })
    return error;
  }
};

export const getVehicle = async (userId) =>{
  var config = {
    headers: authHeader(),
    "Content-type": "application/json",
  };
  const response = await axios.get(
    `${API_REQUEST_URL}parameters/get-vehicles?userId=${userId}`,
    config
  );
  return response.data;
}

//Requests
export const cancelRequest = async (id) => {
  var config = {
    headers: authHeader(),
    'Content-type': 'application/json',
  }
  try{
    const response = await axios.put(
      `${API_REQUEST_URL}request/v1/cancel-request`,
      { 
        requestId: id,
        requestDescription: null
      },
      config
    );
    Swal.fire({
      icon: "success",
      title: "Solicitud cancelada",
      text: `La solicitud ha sido cancelada con exito`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
      
    })
    window.location.reload()
    return response.data
  }catch(error){
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: `${error.response.data.message}`,
      confirmButtonText: "Ok",
      confirmButtonColor: "#3085d6",
    });
    return error
  }
}

export default {
    createRequest,
    getRequest,
    editVehicle
};